import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent, CardMedia } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import styles from './styles';
import MaleIcon from '../../../../../../../../assets/images/Drawer/male.jpg';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { Link, browserHistory, Route, withRouter, Switch, BrowserRouter as Router } from 'react-router-dom';

class DrawerHeader extends Component {
  render(){
    const { classes, theme } = this.props;

    let email = this.props.customer_email;
    let corrected_email = email.substr(0, email.indexOf('@'));
    return(
      <div className={classes.backgroundProperties}>
        <div className={classes.drawerHeader}>
          <Card className={classes.card}>
            <CardMedia
              className={classes.cardCover}
              image={MaleIcon}
            />
            <CardContent className={classes.cardContent}>
              <Typography type="title" className={classes.textFontSize}>{corrected_email}</Typography>
              <Typography type="subheading" color="secondary" className={classes.textFontSize}>
                USA
              </Typography>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        customer_email: state.customer_email.email,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(DrawerHeader)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/components/Header/index.js